import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';
import { makePermissionMeta } from '@/shared/helpers/permissions.helpers';

export const FormsRoutes: RouteRecordRaw[] = [
    {
        path: '',
        redirect: '/forms/submissions'
    },
    {
        path: 'submissions',
        component: wrapRuntimeImport(() => import('./screens/submissions.vue')),
        meta: makePermissionMeta('forms')
    },
    {
        // The form list. Gated on `forms.edit` — someone who can only read submissions has no
        // business authoring forms. Tenant admins hold that capability by default.
        path: 'manage',
        component: wrapRuntimeImport(() => import('./screens/forms.vue')),
        meta: { ...makePermissionMeta('forms', 'edit'), subAppName: 'Forms' }
    },
    {
        // The builder, a page of its own rather than a modal over the list: it's a full workspace, it
        // owns unsaved state worth surviving a reload, and this makes a form directly linkable.
        // `subAppName` is left unset — the screen sets the form's own name via useSubAppName.
        path: 'manage/:formId',
        component: wrapRuntimeImport(() => import('./screens/forms/form-builder.vue')),
        meta: makePermissionMeta('forms', 'edit')
    }
];
